@import 'ss-ui-client/src/constants/spacing.module.less';

.textArea {
  width: 100%;
  padding: @space-8;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: var(--blue-400);
  }
}
